import { render, staticRenderFns } from "./ReserveIPAddr.vue?vue&type=template&id=266edf4d&scoped=true"
import script from "./ReserveIPAddr.vue?vue&type=script&lang=js"
export * from "./ReserveIPAddr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266edf4d",
  null
  
)

export default component.exports